import { Col, Row } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';

import { useAppSelector } from '@/store/hooks';

import { TRentProduct, ProductCard } from '@/entities/product';

import { useTranslate } from '@/shared/hooks/use-translate';
import { CatalogBookIcon, HeartIcon } from '@/shared/ui/icons';

import {
    StyledFavoriteBlockContainer,
    StyledFavoriteEmptyContainer,
    StyledFavoriteEmptyLink,
    StyledFavoriteEmptySubtitle,
    StyledFavoriteEmptyTitle,
} from './styled';

type TProps = {
    favorites: TRentProduct[];
};

export const FavoriteBlock: React.FC<TProps> = ({ favorites }) => {
    return (
        <StyledFavoriteBlockContainer>
            <Row gutter={[16, 16]}>
                {favorites.map((product, index) => (
                    <Col key={index} span={24} lg={6} md={8} sm={12}>
                        <ProductCard product={product} className="card" />
                    </Col>
                ))}
            </Row>
        </StyledFavoriteBlockContainer>
    );
};

export const FavoriteBlockEmpty: React.FC = () => {
    const theme = useTheme();
    const cityUser = useAppSelector((state) => state.user.cityUser);

    const { t } = useTranslate();

    return (
        <StyledFavoriteEmptyContainer>
            <Image width={79} height={77} src="/static/icons/favorite.png" alt="favorite" />
            <StyledFavoriteEmptyTitle>{t('В избранном пусто')}</StyledFavoriteEmptyTitle>
            <StyledFavoriteEmptySubtitle>
                {t('Добавляйте товары с помощью')} <HeartIcon width="24" color={theme.color.primary} />
            </StyledFavoriteEmptySubtitle>
            <Link href={`${cityUser.slug}`}>
                <StyledFavoriteEmptyLink>
                    <CatalogBookIcon /> {t('К каталогу')}
                </StyledFavoriteEmptyLink>
            </Link>
        </StyledFavoriteEmptyContainer>
    );
};
